import { render, staticRenderFns } from "./TagsPage.vue?vue&type=template&id=de3b7f0c&scoped=true&"
import script from "./TagsPage.vue?vue&type=script&lang=js&"
export * from "./TagsPage.vue?vue&type=script&lang=js&"
import style0 from "./TagsPage.vue?vue&type=style&index=0&id=de3b7f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3b7f0c",
  null
  
)

export default component.exports